import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import ClientPortfolio from '@/pages/ClientPortfolio';
import ProductsSolutions from '@/pages/ProductsSolutions';
import ContactPage from '@/pages/ContactPage';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/portfolio" element={<ClientPortfolio />} />
          <Route path="/products" element={<ProductsSolutions />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;